import React from 'react';
import { default as __ } from '../../../utils';
import { colors } from '../../../styles';
import Stat from './stat';
import Chart from '../../../components/charts';
import Title from '../../../components/title';
import CourtSide from '../../../components/padel/court-side';

function Positions(props) {
  let { universe, victories, victoriesLeft, left } = props;
  let isLandscape = __.useMediaQuery('(orientation: landscape)');

  return (
    <section className="owl-xl">
      <div>
        <div
          className={
            isLandscape
              ? 'row-between align-center'
              : 'col-between align-center'
          }
        >
          <Title label={'Sides'} vertices={9} value={'court'} />

          <div style={{ width: isLandscape ? '400px' : '320px' }}>
            <Chart.Pie
              shades={[colors.black, colors.ultrapurple]}
              chartBg={colors.transparent}
              values={[
                { id: 0, label: 'left', value: left },
                { id: 1, label: 'right', value: universe - left },
              ]}
            />
          </div>
        </div>

        <div stat-display="grid" className="small-container">
          <Stat value={left} legend="played left">
            <CourtSide variant="left" />
          </Stat>

          <Stat legend="played right" value={universe - left}>
            <CourtSide variant="right" />
          </Stat>
        </div>
      </div>
      <div>
        <div
          className={
            isLandscape ? 'row-between align-center' : 'col-start align-center'
          }
        >
          <Title label={'Wins'} vertices={9} value={'Side'} />

          <div style={{ width: isLandscape ? '400px' : '320px' }}>
            <Chart.Pie
              shades={[colors.black, colors.ultrapurple]}
              values={[
                {
                  id: 0,
                  label: 'victories left',
                  value: victoriesLeft.length,
                },
                {
                  id: 1,
                  label: 'victories right',
                  value: victories.length - victoriesLeft.length,
                },
              ]}
            />
          </div>
        </div>

        <div stat-display="grid" className="small-container">
          <Stat
            value={victoriesLeft.length}
            legend={`${__.pluralize(
              victoriesLeft.length,
              'Win',
              's',
              'minimal',
            )} left`}
          >
            <CourtSide variant="left" />
          </Stat>

          <Stat
            legend={`${__.pluralize(
              victories.length - victoriesLeft.length,
              'Win',
              's',
              'minimal',
            )} right`}
            value={victories.length - victoriesLeft.length}
          >
            <CourtSide variant="right" />
          </Stat>
        </div>
      </div>
    </section>
  );
}

export default Positions;
